import React from 'react';
import { BRAND, isMarketGB } from '../../constants/main';
import { StockCardStyledAC } from './AC/StockCardStyled.AC';
import { StockCardStyledACGB } from './AC/StockCardStyled.ACGB';
import { StockCardStyledAP } from './AP/StockCardStyled.AP';
import { StockCardStyledDS } from './DS/StockCardStyled.DS';
import { StockCardStyledOV } from './OV/StockCardStyled.OV';
import { StockCardStyledOVGB } from './OV/StockCardStyled.OVGB';
import { StockCardStyled } from './StockCardStyled';

import { TBudgetType } from '../../interfaces/IFilters';
import { SC } from '../../styles/theme';
import { IVehicleTransformed } from '../../services/stock/models/stockItems.service.model';
import { BrandTypes } from '../../types/brands';

export type StockCardProps = SC & {
    vehicle: IVehicleTransformed;
    paymentJourney: TBudgetType;
    disabled?: boolean;
    isStockSlice?: boolean;
    index: string | number;
    isNeedHandItem?: boolean;
    dealerLocationHeight?: number | string;
};

const StockCard = (props: StockCardProps) => {
    if (BRAND === BrandTypes.AC)
        return isMarketGB ? <StockCardStyledACGB {...props} /> : <StockCardStyledAC {...props} />;
    if (BRAND === BrandTypes.OV)
        return isMarketGB ? <StockCardStyledOVGB {...props} /> : <StockCardStyledOV {...props} />;
    if (BRAND === BrandTypes.AP) return <StockCardStyledAP {...props} />;
    if (BRAND === BrandTypes.DS) return <StockCardStyledDS {...props} />;
    return <StockCardStyled {...props} />;
};

export default StockCard;
